import * as React from 'react';
import cx from 'classnames';

import * as styles from './styles.css';

export interface IButtonLinkProps {
  children: React.ReactNode;
  onClick?(e: React.MouseEvent<HTMLElement>): void;
  block?: boolean;
  fullWidth?: boolean;
  theme?: 'white';
  testId?: string;
  className?: string;
}

export function ButtonLink({ children, block, theme, onClick, testId, fullWidth, className }: IButtonLinkProps) {
  return (
    <button
      data-testid={testId}
      type="button"
      className={cx(
        styles['link'],
        block && styles['link--block'],
        theme && styles[`link--${theme}`],
        fullWidth && styles[`link--fullwidth`],
        className,
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
